<template>
    <div class="pay-record-detail-container">
        <div class="content">
            <div class="card-wrapper">
                <mobile-card>
                    <template slot="title">支付信息</template>

                    <template slot="content">
                        <div class="flex-form-info">
                            <span>订单编号</span>
                            <span>{{selectRecord.orderNo | formatSpaceText}}</span>
                        </div>
                        <div class="flex-form-info">
                            <span>订单状态</span>
                            <span>{{selectRecord.stateStr | formatSpaceText}}</span>
                        </div>
                        <div class="flex-form-info">
                            <span>订单金额</span>
                            <span class="money-item">{{selectRecord.money | formatMoney}}</span>
                        </div>
                        <div class="flex-form-info">
                            <span>创建时间</span>
                            <span>{{selectRecord.createTime | formatSpaceText}}</span>
                        </div>
                        <div class="flex-form-info">
                            <span>支付方式</span>
                            <span>{{selectRecord.payType | formatSpaceText}}</span>
                        </div>
                        <div class="flex-form-info">
                            <span>支付时间</span>
                            <span>{{selectRecord.payTime | formatSpaceText}}</span>
                        </div>

                        <div class="flex-form-info">
                            <span>票据抬头</span>
                            <span>{{selectRecord.ticketTitle | formatSpaceText}}</span>
                        </div>
                    </template>
                </mobile-card>
            </div>
            <div class="card-wrapper">
                <mobile-card>
                    <template slot="title">订单明细</template>

                    <template slot="content">
                        <div v-for="(item, index) in payDetail" :key="index">
                            <div class="flex-form-info">
                                <span>{{ getOrderText(item) }}</span>
                                <span class="money-item">{{item.payMoney | formatMoney}}</span>
                            </div>
                        </div>
                    </template>
                </mobile-card>

            </div>
        </div>

        <div class="nav-bottom">
            <van-button type="primary" size="small" square style="border-radius:5px;width: 120px;background-color: #005423;"
                @click="exportPdf" >发送凭据到邮箱
            </van-button>
            <van-button type="primary" size="small" plain square style="border-radius:5px;margin-left:30px;width: 100px;color:#005423;border-color:#005423;"
                @click="onBack" >返回上一级
            </van-button>
        </div>
        <van-dialog title="邮箱地址" show-cancel-button show-confirm-button confirmButtonColor="#005423" 
        v-model="showDialog"
        :beforeClose="onConfirm">
            <van-field v-model="sendToEmail" style="padding-left: 10px;width: 100%;"                       
                            placeholder="请填入邮箱地址"
                            input-align="left"
                            type="text"></van-field>
        </van-dialog>
    </div>
</template>

<script>
    import log from "utils/log";
    import MobileCard from "components/mobile-card/index";
    import MobileButton from "components/mobile-button/index";
    // import { getState } from "utils/state";
    import storage from 'good-storage'
    import apiChooseFee from "api/choose-fee"
    import apiPayRecord from "api/pay-record";
    import utils from "@/utils/util";

    export default {
        name:'payRecordDetail',
        components: { MobileCard },

        data() {
            return {
                showDialog:false,
                sendToEmail:'',
                orderNo:'',
                selectRecord: {}
            };
        },

        computed: {
            payDetail() {
                log("details", this.selectRecord.details);
                return this.selectRecord.details;
            }
        },

        activated() {
            this.getRecord();
        },

        methods: {
            getRecord() {
                // let r = getState("select-record");
                let r = storage.session.get("select-record",{});
                log("select record ", r);
                if (utils.isEmpty(r)) {
                    this.$router.push("/home");
                    return;
                }

                let param = {
                    orderNo: r.orderNo,
                    outPayNo: r.outPayNo
                };

                apiPayRecord.detail(param).then(res => {
                    let d = res.data;
                    if (utils.isNotEmpty(d)) {
                        this.orderNo = d.orderNo;
                        this.selectRecord = d;
                    }
                });
            },
            exportPdf(){
                this.showDialog = true	
            },
            onConfirm(action,done){
                if(action==='cancel'){
                    done();
                }else if(action === 'confirm'){
                    let orderNo = this.$route.query.order_no
                    apiChooseFee.sendEmail({orderNo: this.orderNo,email:this.sendToEmail}).then(res=>{
                        this.$notify({
                            type: "success",
                            message: "邮件已发送"
                        });
                        done();
                    }).catch(err=>{
                        done();
                    });
                   
                }
            },
            getOrderText(item) {
                let s = ''
                if (item.intervalName) {
                    s = `${item.intervalName}  `
                    if (item.itemName) {
                        let s2 = `${ item.itemName }`
                        s += s2
                    }
                } else {
                    if (item.itemName) {
                        let s2 = `${ item.itemName }`
                        s += s2
                    }
                }
                return s
            },

            onBack() {
                this.$router.back();
            }
        },
    };
</script>

<style lang='scss' scoped>
    .nav-bottom {
        width: 100%;
        height: 50px;
        line-height: 40px;
        position: absolute;
        bottom: 0px;
        background-color: white;
        font-size: 16px;
        color: #005423;
        text-align: center;
    }
</style>
